export const COOKIE_BANNER_CLOSED = 'COOKIE_BANNER_CLOSED';
export const EMAIL_TO_VERIFICATE  = 'EMAIL_TO_VERIFICATE';
export const USER_DATA            = 'USER_DATA';
export const ACCESS_TOKEN         = 'ACCESS_TOKEN';
export const CHECKOUT_PAGE        = 'CHECKOUT_PAGE';
export const PORTAL_PAGE          = 'PORTAL_PAGE';

export const USER_PACK_DATA = 'USER_PACK_DATA_';

export const BUNDLE_2022_STRIPE_PRICE_ID = 'BUNDLE_2022_STRIPE_PRICE_ID';